<eze-modal #modal (onOpen)="onModalOpen()">
	<eze-modal-header>
		<h1>Enter Payment Code</h1>
	</eze-modal-header>
	<eze-modal-content>
		<eze-alert></eze-alert>

		<h3 *ngIf="paymentCode" class="text-center">
			<div class="text-success" style="font-size: 1.5em;">
				<i class="fa fa-check"></i>
			</div>
			<br />
			Payment code applied.
		</h3>

		<form
			class="smart-form"
			novalidate
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
			*ngIf="!paymentCode"
		>
			<div class="row">
				<div class="col-xs-12">
					<eze-input-container>
						<input
							ezeInput
							type="text"
							id="payment_code"
							formControlName="payment_code"
							[showValidation]="showValidation"
						/>
					</eze-input-container>
				</div>

				<button type="subimit" style="display: none;"></button>
			</div>
		</form>
	</eze-modal-content>
	<eze-modal-footer>
		<eze-button
			(click)="modal.close()"
			context="default"
			style="margin-right: 10px;"
			>Cancel</eze-button
		>
		<eze-button (click)="onSubmit()" context="success">Submit</eze-button>
	</eze-modal-footer>
</eze-modal>
